import React, { useState } from 'react';
import { Tabs } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faVolumeHigh, faFileAlt, faCog } from '@fortawesome/free-solid-svg-icons';
import CallVolumeTracking from './CallVolumeTracking';
import RecordingManagement from './RecordingManagement';
import CategoryManagement from './components/CategoryManagement';

const { TabPane } = Tabs;

const CallAnalytics = () => {
  const [activeTab, setActiveTab] = useState('volume');

  return (
    <div style={{ padding: '24px' }}>
      <Tabs 
        activeKey={activeTab} 
        onChange={setActiveTab}
        size="large"
      >
        <TabPane
          tab={
            <span>
              <FontAwesomeIcon icon={faPhone} style={{ marginRight: 8 }} />
              Call Volume Tracking
            </span>
          }
          key="volume"
        >
          <CallVolumeTracking />
        </TabPane>
        <TabPane
          tab={
            <span>
              <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: 8 }} />
              Recording Management
            </span>
          }
          key="recordings"
        >
          <RecordingManagement />
        </TabPane>
        <TabPane
          tab={
            <span>
              <FontAwesomeIcon icon={faVolumeHigh} style={{ marginRight: 8 }} />
              Call Quality Analysis
            </span>
          }
          key="quality"
          disabled
        >
          <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
            <FontAwesomeIcon icon={faVolumeHigh} style={{ fontSize: '48px', marginBottom: '16px' }} />
            <h3>Call Quality Analysis</h3>
            <p>This feature will be available in Phase 4</p>
            <p style={{ fontSize: '14px' }}>
              Includes call transcription, quality scoring, and negative keyword analysis
            </p>
          </div>
        </TabPane>
        <TabPane
          tab={
            <span>
              <FontAwesomeIcon icon={faCog} style={{ marginRight: 8 }} />
              Category Settings
            </span>
          }
          key="categories"
        >
          <CategoryManagement />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default CallAnalytics;
